var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-content',{staticClass:"h-panel"},[_c('div',{staticClass:"h-panel-bar"},[_c('span',{staticClass:"h-panel-title"})]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }